import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const searchApi = createApi({
    reducerPath: 'searchApi',
    baseQuery : fetchBaseQuery({ 
        baseUrl: "https://apiv2.shwenarsin.com/api/app/",
        prepareHeaders: async (headers) => {
            const customHeaders = await getHeaders('searchApi');
            for (const [key, value] of Object.entries(customHeaders)) {
              headers.set(key, value);
            }
            return headers;
        },
    }),
    endpoints : (builder) => ({
        fetchSearchData : builder.query({
            query : (value) => ({
                url : '/music/searchall',
                method : 'POST',
                body : {
                    platform: "miniapp",
                    keyword : value,
                    user_id : getLocalStorageData(),
                }
            })
        })
    })
})

export const { useFetchSearchDataQuery, endpoints } = searchApi